var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.727,
    cy: 3.4718,
    r: 1.84869,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.80889,
    cy: 3.85118,
    r: 2.22734,
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.754639 11.294C0.754639 9.27823 1.92781 7.45476 3.74464 6.61361C4.94974 7.57297 6.66405 7.57292 7.86909 6.61344C9.69115 7.45466 10.8682 9.28209 10.8682 11.3027V14.275C7.62932 15.5957 3.99852 15.5972 0.754639 14.2731V11.294Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82593 6.17644C9.18013 5.88761 9.57984 5.64735 10.017 5.46777C10.9798 6.35894 12.4663 6.35894 13.4291 5.46777C15.2071 6.19625 16.3685 7.92713 16.3685 9.84859V12.6017C14.8969 13.2335 13.3279 13.5517 11.7577 13.5555V12.8055C13.0667 12.8021 14.3749 12.5653 15.6185 12.0957V9.84859C15.6185 8.3736 14.8053 7.03205 13.5268 6.34244C12.4368 7.06728 11.0098 7.06739 9.91972 6.34276C9.77453 6.42131 9.63536 6.50829 9.50273 6.60293C9.28932 6.44578 9.06334 6.30304 8.82593 6.17644Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamOutline);
export default __webpack_public_path__ + "static/media/team-outline.aa937d797408996315a0f6e1f265a6f3.svg";
export { ForwardRef as ReactComponent };